import { render, staticRenderFns } from "./BrandGuidelines.vue?vue&type=template&id=46a4f5f3&scoped=true"
import script from "./BrandGuidelines.vue?vue&type=script&lang=js"
export * from "./BrandGuidelines.vue?vue&type=script&lang=js"
import style0 from "./BrandGuidelines.vue?vue&type=style&index=0&id=46a4f5f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a4f5f3",
  null
  
)

export default component.exports